<script lang="ts">
import type { HTMLAttributes } from 'vue'

export interface FieldLabelProps {
  for?: string
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '../../lib/utils'
const props = defineProps<FieldLabelProps>()
</script>
<template>
  <component :is="props.for ? 'label' : 'div'" :for="props.for" :class="cn(
    'grid w-full select-none grid-cols-[1fr_auto] items-end gap-0.5 text-xs font-medium text-neutral-700 dark:text-neutral-200 min-h-6',
    props.class
  )
    ">
    <slot />
  </component>
</template>
